import { MARQUEE_WORDS } from "../../data/content";

export function Marquee() {
  const words = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section className="relative py-12 sm:py-16 bg-secondary border-y border-[var(--gold-line)] overflow-hidden" data-testid="marquee" data-section="marquee" data-section-label="Marquee">
      <div className="marquee-track">
        {words.map((w, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-editorial italic text-3xl sm:text-5xl text-gold opacity-60 px-8">{w}</span>
            <span className="text-gold opacity-30 text-2xl">∞</span>
          </span>
        ))}
      </div>
    </section>
  );
}
